<template><VisitList title="همه‌ی ویزیت‌ها" editable /></template>
<script>
import VisitList from './VisitList.vue';
export default { components: { VisitList } };
</script>
